module.exports = __webpack_public_path__ + "media/40.c699582d.wav";